import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';

import { breakpoints } from 'styles/basic';

interface SmallerMarginProps {
  smallerMargin?: boolean | undefined;
}

const List = styled.ul<SmallerMarginProps>`
  display: flex;
  flex-wrap: wrap;
  place-items: stretch center;
  gap: 2rem;
  margin: 2rem 0;
  list-style: none;

  @media (min-width: ${breakpoints.smallLaptop}) {
    gap: 3rem;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  ${(props) => props.smallerMargin && css`
    gap: 2rem;
    margin-top: 2rem;
    margin-bottom: 2rem;

    @media (min-width: ${breakpoints.smallLaptop}) {
      gap: 2rem;
      margin-top: 2rem;
      margin-bottom: 2rem;
    }
  `};
`;

const ListItem = styled.li<SmallerMarginProps>`
  width: calc(50% - 3rem);

  @media (min-width: ${breakpoints.laptop}) {
    width: auto;
  }

  ${(props) => props.smallerMargin && css`
    width: auto;

    @media (min-width: ${breakpoints.laptop}) {
      width: auto;
    }
  `};
`;

const ListItemLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Avatar = styled.span<SmallerMarginProps>`
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  width: 9rem;
  height: 9rem;
  border: .3rem solid ${(props) => props.theme.mainColors.primary};
  border-radius: 50%;
  background: ${(props) => props.theme.color.gray};

  img {
    width: 90%;
  }

  ${(props) => props.smallerMargin && css`
    width: 7rem;
    height: 7rem;

    @media (min-width: ${breakpoints.laptop}) {
      width: 9rem;
      height: 9rem;
    }
  `};
`;

const Name = styled.span`
  display: block;
  margin-top: .5rem;
  font-weight: bold;
  color: ${(props) => props.theme.mainColors.primary};
  text-transform: uppercase;
`;

const Title = styled.span`
  display: block;
  font-size: 1.2rem;
  text-transform: uppercase;
`;

export {
  List,
  ListItem,
  ListItemLink,
  Avatar,
  Name,
  Title
};
